import { Fragment } from "react";
import StaedteError from "./Error";

/**
 * 
 * @param {*} params 
 * @returns 
 */
export default function Bars(params) {

    const barsData   = params.data;
    let errorOccured = undefined !== barsData.errors;
    
    if ( errorOccured ) {
        // TODO: How to handle missing detail data?
        return(
            <Fragment>
                <StaedteError />
            </Fragment>
        );
    } else if ( undefined === barsData || 0 === barsData.length ) {
        return;
    }

    const showSocialDetails = (ev, show) => {

        let target = ev.target.closest('.staedte-bars-card');

        const overlay = target.getElementsByClassName( 'staedte-bars-socials' );

        if ( !overlay || 0 === overlay.length ) {
            return;
        }
        
        if ( null === show ) {
            
            show = "0" === overlay[0].style.overlay;

        }
        
        if ( show ) {
            target.style.transition =  "all ease-in 0.25s";
            target.style.transform = "scale(1.025)";
            overlay[0].style.overlay = "0.8";
        } else {
            overlay[0].style.overlay = "0";
            target.style.transform = "scale(1)";
        }

    }

    return(
        <div className="staedte-bars-container">

            <p className="staedte-bars-header-container">
                <b>
                    {window.staedteFrontendShortcodeData.i18n.participatingBars}
                </b>
            </p>

            
            <p style={{"color": "black"}}>
                {`${barsData.bars.length} ${window.staedteFrontendShortcodeData.i18n.availableBars}`}
            </p>

            <div className="staedte-bars-wrapper">
                {
                    barsData.bars.map(
                        (bar, index) => {

                            let isMaybeValidWebsiteUrl = bar.website && 0 < bar.website.length;
                            if ( isMaybeValidWebsiteUrl ) {
                                try {
                                    new URL( bar.website );
                                    isMaybeValidWebsiteUrl = true;
                                } catch ( e ) {
                                    isMaybeValidWebsiteUrl = false;
                                }
                            }

                            let instagramIsActive = bar.instagram && 0 < bar.instagram.length;
                            let facebookIsActive = bar.facebookIsActive && 0 < bar.facebookIsActive.length;
                            let startTimeIsActive = bar.start_time && 0 < bar.start_time.length;
                            
                            let isMaybeValidImgUrl = bar.image && 0 < bar.image.length;
                            if ( isMaybeValidImgUrl ) {
                                try {
                                    new URL( `https://bierbachelor.com/${bar.image}` );
                                    isMaybeValidImgUrl = true;
                                } catch ( e ) {
                                    isMaybeValidImgUrl = false;
                                }
                            }

                            return(
                                <div
                                    key={index}
                                    className={`staedte-bars-card text-decoration-none`}
                                >
                                    <div className="card staedte-bars-inner-wrapper">
                                        
                                        <div
                                            className="staedte-bars-img-wrapper"
                                        >
                                            <img
                                                className={'staedte-bars-img'}
                                                alt={bar.image} src={ isMaybeValidImgUrl ? `https://bierbachelor.com/${bar.image}` : 'https://bierbachelor.com/logos/no_image.jpg'}
                                            />
                                        </div>

                                    </div>
                                    

                                    <div className="staedte-bars-socials-wrapper">

                                        <div className="d-flex mt-auto flex-column flex-lg-row justify-content-center">
                                            
                                            <div className="d-flex flex-row justify-content-center">

                                                {
                                                    (isMaybeValidWebsiteUrl && isMaybeValidImgUrl ) ?
                                                    <div className="p-1 d-flex">
                                                        <a 
                                                            href={bar.website}
                                                            role="button"
                                                            target="_blank"
                                                            rel="noreferrer"
                                                            className="dashicons staedte-bars-social-icon dashicons-admin-site"
                                                            style={{
                                                                color: "black",
                                                                lineHeight: 1.3
                                                            }}
                                                        >
                                                        </a>
                                                    </div> :
                                                    ''
                                                }
                                                {
                                                    (instagramIsActive && isMaybeValidImgUrl ) ?
                                                    <div className="p-1 d-flex">
                                                        <a
                                                            href={`https://www.instagram.com/${bar.instagram}`}
                                                            role="button"
                                                            target="_blank"
                                                            rel="noreferrer"
                                                            className="dashicons staedte-bars-social-icon dashicons-instagram"
                                                            style={{
                                                                color: "black",
                                                                lineHeight: 1.3
                                                            }}
                                                        >    
                                                        </a>
                                                    </div> :
                                                    ''
                                                }
                                                {
                                                    (facebookIsActive && isMaybeValidImgUrl ) ?
                                                    <div className="p-1 d-flex">
                                                        <a
                                                            href={`https://www.facebook.com/${bar.facebook}`}
                                                            role="button"
                                                            target="_blank"
                                                            rel="noreferrer"
                                                            className="dashicons staedte-bars-social-icon dashicons-facebook"
                                                            style={{
                                                                color: "black",
                                                                lineHeight: 1.3
                                                            }}
                                                        >    
                                                        </a>
                                                    </div> :
                                                    ''
                                                }

                                            </div>


                                            {
                                                (startTimeIsActive  && isMaybeValidImgUrl ) ?
                                                <div
                                                    className="p-1 d-flex flex-row text-center ms-auto me-auto ms-lg-0 me-lg-0"
                                                    style={{color: "black"}}
                                                >  
                                                    <span
                                                        class="mt-auto mb-auto staedte-bars-social-icon dashicons dashicons-clock"
                                                    ></span>                                    
                                                    <span
                                                        className="mt-auto mb-auto staedte-bars-clock-time"
                                                        style={{
                                                            fontSize: "18px"
                                                        }}
                                                    >&nbsp;{`${bar.start_time} ${window.staedteFrontendShortcodeData.i18n.clock}*`}</span> 
                                                </div> :
                                                ''
                                            }

                                            {
                                                ( ! isMaybeValidImgUrl ) ?
                                                <div
                                                    className="p-1 d-flex flex-row text-center ms-auto me-auto ms-lg-0 me-lg-0"
                                                    style={{color: "black"}}
                                                >                                 
                                                    <span
                                                        className="mt-auto mb-auto"
                                                        style={{
                                                            fontSize: "18px"
                                                        }}
                                                    >
                                                        {bar.locationName}
                                                    </span> 
                                                </div> :
                                                ''
                                            }
                                        </div>
                                    </div>
                                
                                </div>
                            );
                        }
                    )
                }
            </div>

        </div>
    );

}